import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { FlagContext } from './FlagContext';
import { isFlagEnabled } from './helpers';
const withFeatureBranch = (featureToComponentMap)=>(Component)=>{
        const DecoratedFC = /*#__PURE__*/ React.forwardRef((props, ref)=>{
            const flags = useContext(FlagContext);
            const enabled = Object.keys(featureToComponentMap).filter((feature)=>isFlagEnabled(flags, feature)).map((feature)=>featureToComponentMap[feature]);
            // use the first one
            const FeatureComponent = enabled.length ? enabled[0] : Component;
            return /*#__PURE__*/ React.createElement(FeatureComponent, _extends({
                ref: ref
            }, props));
        });
        DecoratedFC.displayName = `withFeatureBranch(${Component.displayName || 'Component'})`;
        return DecoratedFC;
    };
export default withFeatureBranch;
